import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/app/Home';
import JobHome from './components/JobHome/JobHome';
import DailyJobs from './components/DailyJobs/DailyJobs';
import HireTalentsPage from './components/HireTalent/HireTalentsPage';
import history from './history';
import PostTalentPage from './components/PostTalent/PostTalentPage';
import PageNotFound from './components/utils/PageNotFound';
import BlogsPage from './components/misc/BlogsPage';
import BlogsSearchPage from './components/misc/BlogsSearchPage';
import Blog from './components/misc/Blog';
import AboutUsPage from './components/misc/AboutUsPage';
import FAQPage from './components/misc/FAQPage';
import BrowseJobs from './components/BrowseJobs/BrowseJobs';
import LoginPage from './components/misc/LoginPage';
import SignupPage from './components/misc/SignupPage';
import { isAuthenticated } from './components/utils/ComponentUtil';
import ProfilePage from './components/user/ProfilePage';
import EditProfilePage from './components/user/EditProfilePage';
import TalentDetailsPage from './components/Talent/TalentDetailsPage';
import HireTalentPage from './components/HireTalent/HireTalentPage';
import PaymentProofs from './components/user/PaymentProofs';
import EarningSummary from './components/user/EarningsSummary';
import InternshipsPage from './components/Internship/InternshipsPage';
import InternshipsSearchPage from './components/Internship/InternshipsSearchPage';
import InternshipDetailsPage from './components/Internship/InternshipDetailsPage';
import PostProjectPage from './components/PostTalent/PostProject';
import FindProjectsPage from './components/FindProject/FindProjectsPage';
import PostJobPage from './components/Jobs/PostJobPage';
import ProjectDetailsPage from './components/Talent/ProjectDetailsPage';
import Home1 from './components/app/Home1';

function App() {

  const isLoggedIn = isAuthenticated();
  const openPages = <>
        <Route path='/' element={!isLoggedIn ? <Home /> : <JobHome />} />
        <Route path='/home' element={!isLoggedIn ? <Home /> : <JobHome />} />
        <Route path='/home1' element={<Home1 />} />
        <Route path='/internships/custom/:job' element={<DailyJobs />} />
        <Route path='/browse-jobs/:job' element={<BrowseJobs/>} />
        <Route path='/blogs' element={<BlogsPage />} />
        <Route path='/about-us' element={<AboutUsPage />} />
        <Route path='/faq' element={<FAQPage />} />
        <Route path='/blogs/:blogId' element={<Blog />} />
        <Route path='/blogs/search' element={<BlogsSearchPage />} />
        <Route path='/blogs/:blogId/search' element={<BlogsSearchPage />} />
        <Route path='/hire-talent/' element={<HireTalentsPage />} />
        <Route path='/hire-talent/:talent' element={<HireTalentsPage />} />
        <Route path='/hire-talent/:talent/:subType' element={<HireTalentsPage />} />
        <Route path='/hire-talent/:talent/search' element={<HireTalentsPage />} />
        <Route path='/hire-talent/:talent/:subType/search' element={<HireTalentsPage />} />
        <Route path='/hire-talent/:talent/:subType/:id' element={<TalentDetailsPage />} />
        <Route path='/find-project/' element={<FindProjectsPage />} />
        <Route path='/find-project/:type' element={<FindProjectsPage />} />
        <Route path='/find-project/:type/:subType' element={<FindProjectsPage />} />
        <Route path='/find-project/:type/search' element={<FindProjectsPage />} />
        <Route path='/find-project/:type/:subType/search' element={<FindProjectsPage />} />
        <Route path='/find-project/:talent/:subType/:id' element={<ProjectDetailsPage />} />
        <Route path='/internships' element={<InternshipsPage />} />
        <Route path='/internships/:id' element={<InternshipDetailsPage />} />
        <Route path='/internships/search' element={<InternshipsSearchPage />} />
        <Route path='/login' element={isLoggedIn ? <JobHome /> : <LoginPage />} />
        <Route path='/signup' element={isLoggedIn ? <JobHome /> : <SignupPage />} />
  </>

  return (
    <Router history={history}>
      <Routes> 
        {
          isLoggedIn ? 
            <>
            {openPages}
            <Route path='/hire-talent/:talent/:subtype/:id/hire' element={<HireTalentPage />} />
            <Route path='/find-project/:type/:subtype/:id/hire' element={<HireTalentPage />} />
            <Route path='/post-talent/:talent' element={<PostTalentPage />} />
            <Route path='/post-project/:project' element={<PostProjectPage />} />
            <Route path='/post-job/' element={<PostJobPage />} />
            <Route path='/payment-proof' element={<PaymentProofs />} />
            <Route path='/payment-proof/search' element={<PaymentProofs />} />
            <Route path='/earnings' element={<EarningSummary />} />
            <Route path='/profile' element={<ProfilePage />} />
            <Route path='/setting/:category' element={<EditProfilePage />} />
            <Route path="*" element={<PageNotFound />} />
            </> :
            <>
            {openPages}
            <Route path="*" element={<LoginPage />} />
            </>
        }
      </Routes>
    </Router>
  );
}

export default App;
